import { fixUtf8 } from './fixUtf8';

const OBFUSCATED_FIELDS = ['address', 'phoneNr', 'emailMapdot', 'website', 'coordinatesLatLong'];

const TEXT_FIELDS = ['title', 'publicName', 'description', 'city', 'country', 'address'];

function decodeField(value) {
  if (!value || typeof value !== 'string') return value;
  try {
    const binary = atob(value);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const decoded = new TextDecoder('utf-8').decode(bytes);
    try { return JSON.parse(decoded); } catch { return decoded; }
  } catch {
    return value;
  }
}

export function deobfuscateMapdot(mapdot) {
  if (!mapdot || typeof mapdot !== 'object') return mapdot;
  const result = { ...mapdot };

  OBFUSCATED_FIELDS.forEach((field) => {
    if (result[field] != null) {
      result[field] = decodeField(result[field]);
    }
  });

  TEXT_FIELDS.forEach((field) => {
    if (typeof result[field] === 'string') {
      result[field] = fixUtf8(result[field]);
    }
  });

  return result;
}

export function deobfuscateMapdots(mapdots) {
  if (!Array.isArray(mapdots)) return mapdots;
  return mapdots.map(deobfuscateMapdot);
}
